import styled from 'styled-components';

export const ContactSection = styled.section`
  &#grid-row {
    overflow: hidden;
    padding: 40px 50px 80px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 100px;
    @media (max-width: 1023px) {
      gap: 40px;
      padding: 0 25px 40px ;
    }
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
  &#grid-column {
    display: flex;
    flex-direction: column;
    padding: 80px 50px;
    margin: 0 auto;
    gap: 40px;
    max-width: 786px;
    @media (max-width: 768px) {
      gap: 20px;
      max-width: 100%;
    }
    
    h2, p {
      text-align: center
    }
  }
  h2 {
    margin-top: 0px;
    margin-bottom: 40px;
    @media (max-width: 768px) {
      margin-bottom: 20px;
    }
  }
`;

export const ContactPageSection = styled.section`
  .section-banner {
    height: calc(100vh - 80px);
    background-color: var(--hero-overlay);
    &-text {
      position: absolute;
      left: 50px;
      bottom: 90px;
      color: var(--white);
      max-width: 50vw;
      
      @media (max-width: 1023px) {
        max-width: 80%;
        left: 25px;
        bottom: 50px;
      }
    }
    h1 {
      margin: 0;
    }
    .gatsby-image-wrapper {
      position: relative;
      display: block;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    .overlay {
      background: var(--contact-overlay);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      clip-path: polygon(0 0, 40% 0, 80% 100%, 0% 100%);
      
      @media (min-width: 1024px) {
       clip-path: polygon(0 0, 21% 0, 70% 100%, 0% 100%);
      }
      @media (max-width: 768px)  {
        clip-path: none;
        opacity: 0.2;
      }
    }
  }
  .section-intro, .section-blocks {
    padding: 80px 50px 80px;
    @media (max-width: 1023px) {
      padding: 40px 25px;
    }
    h2 {
      margin-top: 0;
    }
  }
`;